module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.c28e5b4e.jpg";